import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMessage } from '@mnz-core/models/message';

@Component({
  selector: 'mnz-messageRenderer',
  templateUrl: './messageRenderer.component.html',
})
export class MessageRendererComponent implements OnInit {
  @Input() message: IMessage;
  @Input() class: string;
  @Output() close = new EventEmitter<IMessage>();

  ngOnInit() {
    if (!this.class) {
      this.class = 'usabilla-dont-show nes-w-full lg:nes-w-8/12 nes-mt-8';
    }
  }
}
